import axios from '../utils/axios';

export default function getRecruiterFollowUpReport (adminId, params) {
    return axios.get(`/admin/${adminId}/get-followup-report`, { params });
}